'use strict'

const Video = {
  playerContainers: $('.video__player:not(#video__modal,.video__modal,.video__player--native)'),
  players: []
}

// Used to publicy expose initialized players
window.videoPlayers = []

Video.init = function () {
  if (Video.playerContainers.length <= 0) {
    return
  }

  if (typeof Plyr === 'undefined') {
    return
  }

  Video.playerContainers.each(function (i, player) {
    Video.players.push(new Plyr(player, {
      muted: true,
    }))
  })

  window.videoPlayers = Video.players
}

export { Video }


$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on('resize scroll', function() {
  $('.video__player').each(function(){
    if ($(this).isInViewport()) {
        $(this)[0].play();
    } else {
        $(this)[0].pause();
    }
  })
});